// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-block-custom li {\n  border: 1px solid #339162 !important;\n  min-width: 75px;\n  margin: 0 0.25rem 0.25rem 0;\n}\n.acitve-block-custom-form {\n  background: #339162 !important;\n  color: #ffffff !important;\n  border: 1px solid #339162 !important;\n  border-radius: unset !important;\n}", ""]);
// Exports
module.exports = exports;
